import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AuthenticationResult } from '../../domain/users/authenticate-user';
import { Login } from '../../domain/users/login-user';
import { store } from '../../domain/users/store';
import { UpdateUserPassword } from '../../domain/users/update-user-password';
import { UserDTO } from './dtos/userDTO';

const ssoAgentInstence = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const requestWithTokenInterceptor = (config: AxiosRequestConfig) => {
    const token = store.commonStore.token;

    if (token) config!.headers!.Authorization = `Bearer ${token}`;

    return config;
};

ssoAgentInstence.interceptors.request.use(requestWithTokenInterceptor);

ssoAgentInstence.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const responseBody = (response: AxiosResponse) => response.data;

const ssoClient = {
    login: (credentials: Login): Promise<AuthenticationResult> => {
        return ssoAgentInstence
            .post('/accounts/login', credentials)
            .then(responseBody);
    },

    current: (): Promise<AuthenticationResult> => {
        return ssoAgentInstence.get('/accounts/').then(responseBody);
    },

    getMe: (): Promise<any> => {
        return ssoAgentInstence.get('/accounts/me').then(responseBody);
    },

    getUsers: (): Promise<UserDTO[]> => {
        return ssoAgentInstence
            .get('/accounts/get-users-with-assets-management-permission')
            .then(responseBody);
    },

    changePassword: (newCredentials: UpdateUserPassword) => {
        return ssoAgentInstence
            .put('/accounts/update-password', newCredentials)
            .then(responseBody);
    },
};

export default ssoClient;
